module.exports = __webpack_public_path__ + "static/media/1.441fc630.png";